import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";
import { useSiteContext } from "../contexts/SiteProvider";
import { post } from "../services/smartApiService";

// Validation schema

interface Props {
  url: string;
  loadData?: () => void;
  resultsTable?: (data: any) => React.ReactNode;
  maxSize?: number;
  fileTypes?: string[];
  fileTypeMsg?: string;
  subData?: any;
}
const excel_types = [
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/csv",
];

const ImportForm: React.FC<Props> = (props) => {
  const {
    url,
    loadData,
    resultsTable,
    maxSize = 2,
    fileTypeMsg = "only Excel File is Allowed",
    fileTypes = excel_types,
    subData,
  } = props;

  const [dragActive, setDragActive] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [results, setResult] = useState([]);

  const schema = Yup.object().shape({
    file: Yup.mixed()
      .required("A file is required")
      .test("fileSize", "File must be smaller than 2MB", (value: any) =>
        value ? value.size <= maxSize * 1024 * 1024 : true
      )
      .test("fileType", fileTypeMsg, (value: any) =>
        value ? fileTypes.includes(value.type) : true
      ),
  });
  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const { closeModal } = useSiteContext();
  const [types, setTypes] = useState([]);
  useEffect(() => {}, []);

  const onSubmit = (formData: any) => {
    // console.log("formdat", subData);
    let post_data = { ...formData };
    if (subData) {
      post_data = { ...post_data, ...subData };
    }
    const subscription = post(url, post_data).subscribe((response) => {
      if (loadData) {
        loadData();
      }
      if (
        response &&
        response.data &&
        response.data.length > 0 &&
        resultsTable
      ) {
        setResult(response.data);
      } else {
        closeModal();
      }
    });
    return () => subscription.unsubscribe();
  };

  const handleDrag = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(e.type === "dragover");
  };

  const readFileContent = (file: any) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === "string") {
          const base64Content = reader.result.split(",")[1]; // Base64 content
          resolve(base64Content);
        } else {
          resolve("");
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const updateFile = async (file: any) => {
    //  console.log("file " , file);
    let _file = {
      name: file.name,
      type: file.type,
      size: file.size,
      content: await readFileContent(file),
    };
    setValue("file", _file, { shouldValidate: true });
    // console.log("file changed", _file);
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0];
      setUploadedFile(file);
      updateFile(file);
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      setUploadedFile(file);
      updateFile(file);
    }
  };

  const labelComponent = () => {
    return (
      <>
        <div
          className="file is-centered is-boxed is-link is-large has-name"
          onDragEnter={handleDrag}
          onDragOver={handleDrag}
          onDragLeave={handleDrag}
          onDrop={handleDrop}
        >
          <label className="file-label">
            <input
              className="file-input"
              type="file"
              name="resume"
              onChange={handleFileChange}
            />
            <span className="file-cta">
              Drag and drop a file here, or{" "}
              <span className="file-icon">
                <i className="fas fa-upload"></i>
              </span>
              <span className="file-label"> </span>
            </span>
            {uploadedFile && (
              <span className="file-name">
                {uploadedFile && uploadedFile?.name} ({" "}
                {(uploadedFile.size / 1024 / 1024).toFixed(2)} MB )
              </span>
            )}
          </label>
        </div>
        {errors.file && (
          <p className="help is-danger has-text-centered">
            {errors.file.message}
          </p>
        )}
      </>
    );
  };
  const elements: SdsFormElementProps[] = [
    {
      type: "LABEL",
      width: 12,
      name: "sd_leave_types_id",
      labelComponent: labelComponent(),
      element: {},
    },
    {
      type: "BUTTON",
      width: 12,
      name: "submitbutton",
      class_name: "has-text-right",
      element: {
        label: "Import",
        onClick: handleSubmit(onSubmit),
        classList: ["smart-action-button"],
      },
    },
  ];

  const clearData = () => {
    setResult([]);
    setUploadedFile(null);
  };

  return (
    <>
      <div className="sd-hims-input">
        {results.length == 0 && (
          <SdsForm elements={elements} errors={errors} control={control} />
        )}
      </div>
      <div>
        {results && results.length > 0 && resultsTable && (
          <>
            {resultsTable(results)}
            {/* <button className="button is-danger" onClick={clearData}>
              ReTry
            </button> */}
          </>
        )}
      </div>
    </>
  );
};

export default ImportForm;
